<template>
<div class="suggestion-list">
    <Loader v-if="isLoadingSuggestions && !isPaginating" />
    <template v-else-if="suggestions.length">
        <transition-group
            name="list"
            tag="div"
            @before-enter="beforeEnter"
            @after-enter="afterEnter"
            appear>
            <!-- TODO: Eventually, any type of component can be rendered
            into this list, not just Suggestion.Vue -->
            <Suggestion
                v-for="(s, i) in suggestions"
                :list-index="i"
                :key="s.id"
                :suggestion="s" />
        </transition-group>
        <LoadMore
            :isLoading="isPaginating"
            :hasSuggestions="hasSuggestions"
            :hasMorePages="hasMorePages"
            :hasError="!!err"
            :lastScrollToBottomDate="lastScrollToBottomDate"
            @loadMore="loadMore"/>
    </template>
    <div v-else class="no-posts is-size-5 has-text-centered">
        <p class="has-text-grey">
            {{ noPostsYet }}
        </p>
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

import * as C from '@shared/constants'
import { ADD_SUGGESTIONS } from '@/store/mutations'
import Suggestion from './Suggestion'
import LoadMore from './LoadMore'

export default {
    name: 'SuggestionList',
    props: {
        suggestions: Array,
        lastScrollToBottomDate: Date,
    },
    data: () => ({
        isPaginating: false,
        err: null,
    }),
    computed: {
        ...mapGetters([
            'isLoadingSuggestions',
            'channelName',
            'listType',
            'hasSuggestions',
            'hasMorePages',
        ]),
        noPostsYet (vm) {
            switch (vm.listType) {
                case C.LIST_TYPE_PENDING:
                    return vm.$t('noPendingPosts')
                case C.LIST_TYPE_USER:
                    return 'You haven\'t posted yet!?'
                case C.LIST_TYPE_BROADCASTER_LIKES:
                    return `${vm.channelName} hasn't liked anything yet?!`
                case C.LIST_TYPE_VOTES:
                default:
                    return vm.$t('noPostsYet')
            }
        },
    },
    methods: {
        // setting transition-delay thru CSS doesn't work for w/e reason.
        beforeEnter ($el) {
            // Only stagger the first page, the rest aren't visible.
            // And you don't want paginated posts to have a delay, it looks bad.
            const index = Number($el.getAttribute('list-index'))
            if (index >= 10) { return }

            const delay = `${index * 75}ms`
            $el.style.transitionDelay = delay
        },
        afterEnter ($el) {
            $el.style.transitionDelay = null
        },
        async loadMore () {
            if (!this.hasMorePages || this.isPaginating) {
                return
            }

            try {
                this.err = null
                this.isPaginating = true

                const payload = { mutation: ADD_SUGGESTIONS }
                await this.$store.dispatch('fetchSuggestions', payload)
            } catch (err) {
                this.err = err
                Sentry.captureException(err)
            } finally {
                this.isPaginating = false
            }
        },
    },
    components: {
        Suggestion,
        LoadMore,
    }
}
</script>

<style lang="scss" scoped>
.suggestion-list, .no-posts {
    flex: 1; // is a flex child of it's container
    display: flex;
    flex-direction: column;
    transition: background-color $default-transition-duration;
}

.no-posts,
/deep/ .loader-wrapper {
    padding: 2rem 1rem;
}

.load-more {
    margin-top: auto;
}

.list-enter-active,
.list-move {
    // https://easings.net/en#easeOutExpo
    transition: .25s;
}

.list-leave-active {
    display: none;
}

.list-enter {
    opacity: 0;
    //transform: translateY(30px);
}
</style>
